import { render, staticRenderFns } from "./ztModal.vue?vue&type=template&id=067d73ba&scoped=true"
import script from "./ztModal.vue?vue&type=script&lang=js"
export * from "./ztModal.vue?vue&type=script&lang=js"
import style0 from "../../../../../src/styles/components/ztModal.css?vue&type=style&index=0&id=067d73ba&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d73ba",
  null
  
)

export default component.exports